import type { CaptureResult } from "@posthog/types";
import { sanitizeAnalyticsProperties } from "./sanitizeAnalyticsUrl";

export const sanitizePostHogCapture = (
  event: CaptureResult,
): CaptureResult => ({
  ...event,
  properties: sanitizeAnalyticsProperties(
    event.properties as Record<string, unknown>,
  ),
});

export const posthogBeforeSend = (
  event: CaptureResult | null,
): CaptureResult | null => {
  if (!event) {
    return null;
  }

  return sanitizePostHogCapture(event);
};
